import { Platform, useWindowDimensions } from "react-native";

const useWindow = () => {
  const { width, height } = useWindowDimensions();
  const isDesktop = Platform.OS === "web" && width > 1024;
  return { isDesktop };
};

export default useWindow;
